import { FC, PropsWithChildren, useMemo } from 'react';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';
import { CompanyTypeId } from 'app/constants/user';

import AuthRoute from './AuthRoute';
import CompanyTypeRestrictor from '../providers/CompanyTypeRestrictor';

// Local Typings
interface Props {
  permittedCompanyTypeId: CompanyTypeId;
}

// Component Definition
const AuthRouteWithCompanyType: FC<PropsWithChildren<Props>> = ({
  children,
  permittedCompanyTypeId,
}) => {
  const user = useGetUser();

  const permittedCompanyTypeIds = useMemo(() =>
    [permittedCompanyTypeId],
  [permittedCompanyTypeId]);

  if (user) {
    return (
      <CompanyTypeRestrictor permittedCompanyTypeIds={permittedCompanyTypeIds}>
        <AuthRoute>
          {children}
        </AuthRoute>
      </CompanyTypeRestrictor>
    );
  }

  return (
    <AuthRoute>
      {children}
    </AuthRoute>
  );
};

export default AuthRouteWithCompanyType;
